/* import __COLOCATED_TEMPLATE__ from './new-phone-call.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import templateOnlyComponent from '@ember/component/template-only';
import type { StepNames, StepType } from 'embercom/objects/visual-builder/configuration-list';

interface NewPhoneCallSignature {
  Args: {
    onSelectStep: (stepName: StepNames) => void;
    stepTypes: StepType;
    readOnly: boolean;
    canUsePhoneCollectData: boolean;
  };
}

export default templateOnlyComponent<NewPhoneCallSignature>();
